import React from 'react';
import { FadeIn } from './FadeIn';
export function UrgencySection() {
  return <section className="bg-crema py-24 px-6" data-id="element-399">
      <div className="max-w-3xl mx-auto text-center" data-id="element-400">
        <FadeIn data-id="element-401">
          <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-10" data-id="element-402">
            Cada noche sin este sistema es una noche de sueño perdido para los
            dos
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-texto mb-12 text-left bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-white/50" data-id="element-403">
          <FadeIn delay={0.1} data-id="element-404">
            <p data-id="element-405">No hay drama en esta frase. Es aritmética simple.</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-406">
            <p data-id="element-407">
              Si tu bebé tiene 8 semanas y está despertándose 4 veces por noche
              — y no cambias nada — a las 12 semanas seguirá despertándose 4
              veces por noche.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-408">
            <p data-id="element-409">
              El sueño infantil no mejora solo con el tiempo en ausencia de
              condiciones adecuadas. Mejora cuando el cerebro del bebé recibe
              señales consistentes que le enseñan a atravesar los
              microdespetares sin intervención externa.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-410">
            <p className="font-medium text-azul-noche" data-id="element-411">
              Cada semana que pasa sin esas señales es una semana en que el
              patrón se refuerza — no se resuelve solo.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-412">
          <p className="text-2xl md:text-3xl font-serif text-texto mb-4" data-id="element-413">
            El mejor momento para empezar fue la semana que nació tu bebé.
          </p>
          <p className="text-3xl md:text-4xl font-bold text-azul-noche" data-id="element-414">
            El segundo mejor momento es esta noche.
          </p>
        </FadeIn>
      </div>
    </section>;
}